<template>
  <v-container>
    <p class="title">Title text classes</p>
    <v-divider class="mb-12" />
    <p class="text-h1">H1 / Acto Book</p>
    <p class="text-h2">H2 / Acto Book</p>
    <p class="text-h3">H3 / Acto Book</p>
    <p class="text-h4">H4 / Acto Book</p>
    <p class="text-h5">H5 / Acto Book</p>
    <p class="body-1">Body 1 / Acto Medium</p>
    <p class="body-2">Body 2 / Acto Medium</p>
    <p class="link">Link / Acto Medium</p>
    <p class="caption">Caption / Acto Medium</p>
    <p class="overline">Overline / Acto Medium</p>
  </v-container>
</template>

<script>
export default {
  name: 'UiKitFonts',
  data() {
    return {}
  },
}
</script>
